import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright 2017-2021 @polkadot/ui-keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0
import store from 'store';
export var BrowserStore =
/*#__PURE__*/
function () {
  function BrowserStore() {
    _classCallCheck(this, BrowserStore);
  }

  _createClass(BrowserStore, [{
    key: "all",
    value: function all(cb) {
      store.each(function (value, key) {
        cb(key, value);
      });
    }
  }, {
    key: "get",
    value: function get(key, cb) {
      cb(store.get(key));
    }
  }, {
    key: "remove",
    value: function remove(key, cb) {
      store.remove(key);
      cb && cb();
    }
  }, {
    key: "set",
    value: function set(key, value, cb) {
      store.set(key, value);
      cb && cb();
    }
  }]);

  return BrowserStore;
}();